<template>
    <div>
        <div v-if="loading" layout="row" class="bg-white" style="height: 100%" layout-align="center center">
                <v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
        </div>
        <div v-else layout="column">
            <div layout="column" class="pa-3 pt1-pc pa1-mobile bg-white">
                <div layout="row" layout-align="start center" class="backlink grey--text" layout-wrap>
                    <a layout="row" class="mb1-mobile"  layout-align="start center" @click="$router.push({name: 'surveys-index'})"><v-icon class="mr-1" color="grey">mdi-chevron-left</v-icon>{{$t('surveys.back')}}</a>
                    <span flex></span>
                    <v-menu v-model="menu2" ref="menu2" class="hidden-md-and-up" origin="top right" :nudge-right="40" lazy
                        transition="scale-transition" offset-y full-width>
                        <v-btn slot="activator" flat depressed light color="transparent" small class="ma-0 pa-0" style="min-width: fit-content;">
                            <v-icon color="black">mdi-dots-vertical</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile
                            v-for="(item, index) in menuList"
                            :key="index"
                            @click="item.action"
                            :disabled="item.disabled"
                            >
                            <v-list-tile-action style="min-width: auto">
                            <v-icon :color="item.color ? item.color : 'black'" class="mr-2" :style="item.disabled ? 'color: rgba(0, 0, 0, 0.26) !important' : ''">mdi-{{item.icon}}</v-icon>
                            </v-list-tile-action>

                            <v-list-tile-content>
                            <v-list-tile-title v-text="item.title" :class="[item.text ? item.text + '--text' : '']" :style="item.disabled ? 'color: rgba(0, 0, 0, 0.26) !important' : ''"></v-list-tile-title>
                            </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <div layout="row" class="hidden-sm-and-down" layout-align="start center">
                        <avatar v-if="isMEN && $store.state.men_logo" size="20" :image="$store.state.men_logo" :fullname="survey.created_by" class="mr-1"></avatar>
                        <avatar v-else size="20" :image="getImageData(survey.creator_id)" :fullname="survey.created_by" class="mr-1"></avatar>
                        {{$t('surveys.created_by')}}&nbsp;
                        <span v-if="isCurrent">
                            {{$t('_.yourself')}}
                        </span>
                        <span v-else-if="isMEN">
                            {{$t('_.the')}} MEN
                        </span>
                        <span v-else-if="survey.creator.is_deleted">
                            {{$t('users.inactive')}}
                        </span>
                        <span v-else>
                            {{survey.creator.firstname}} {{survey.creator.lastname}}
                        </span>
                    </div>
                </div>
                <div layout="row" layout-align="start center">
                    <div layout="column" layout-align="center start">
                        <div class="headline font-weight-bold mt-2">{{i18n(survey.title)}}
                        (<span v-for="(l,i) in survey.langs" :key="l.id" class="text-uppercase">{{i == 0 ? l.id : ', ' + l.id}}</span>)</div>
                    </div>
                    <span flex></span>
                    <v-menu v-model="menu" ref="menu" origin="top right" class="hidden-sm-and-down" :nudge-right="40" lazy
                        transition="scale-transition" offset-y full-width>
                        <v-btn slot="activator" flat depressed light color="transparent" small class="ma-0 pa-0 mr-1" style="min-width: fit-content;">
                            <span v-if="!$vuetify.breakpoint. smAndDown" class="message-btn ma-0 light-blue lighten-5"></span>
                            <span v-if="!$vuetify.breakpoint. smAndDown" class="message-btn ma-0 ml-1 cyan"></span>
                            <span v-if="!$vuetify.breakpoint. smAndDown" class="message-btn ma-0 ml-1 secondary"></span>
                        </v-btn>
                        <v-list>
                            <v-list-tile
                            v-for="(item, index) in menuList"
                            :key="index"
                            @click="item.action"
                            :disabled="item.disabled"
                            >
                            <v-list-tile-action style="min-width: auto">
                            <v-icon :color="item.color ? item.color : 'black'" class="mr-2" :style="item.disabled ? 'color: rgba(0, 0, 0, 0.26) !important' : ''">mdi-{{item.icon}}</v-icon>
                            </v-list-tile-action>

                            <v-list-tile-content>
                            <v-list-tile-title v-text="item.title" :class="[item.text ? item.text + '--text' : '']" :style="item.disabled ? 'color: rgba(0, 0, 0, 0.26) !important' : ''"></v-list-tile-title>
                            </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </div>

                <div layout="row" class="full-width">

                    <div layout="column" flex>

                        <div class="grey--text mt-2">
                            <div layout="row" layout-wrap class="hidden-md-and-up" layout-align="start center">
                                {{$t('surveys.created_by')}}&nbsp;
                                <span v-if="isCurrent">
                                    {{$t('_.yourself')}}
                                </span>
                                <span v-else-if="isMEN">
                                    {{$t('_.the')}} MEN
                                </span>
                                <span v-else-if="survey.creator.is_deleted">
                                    {{$t('users.inactive')}}
                                </span>
                                <span v-else>
                                    {{survey.creator.firstname}} {{survey.creator.lastname}}
                                </span>
                            </div>
                            <span>{{$t('surveys.published_on')}}</span>
                            {{formatShortDateHumanI18n(survey.message.date_start)}}, {{$t('surveys.finished_on')}}
                            {{formatShortDateHumanI18n(survey.message.date_end)}}<br>
                            <span>{{$t('surveys.lvs_targeted')}}</span>
                            <span v-for="(l,j) in survey.message.levels" :key="'lv_' + j">
                                {{levelLabel(l.level)}}{{survey.message.levels.length == (j + 1) ? '' : ', '}}
                            </span>
                        </div>
                        <div layout="row" layout-wrap layout-align="start center">
                            <v-chip label :color="surveyStatusColor" class="text-lowercase mx-0" text-color="white" small>
                                {{surveyStatusStr}}
                            </v-chip>
                        </div>
                    </div>
                    <div v-if="!survey.message.is_enabled && isCurrentLevel && survey.message.date_start && survey.message.date_end" layout="column" class="hidden-sm-and-down">
                        <v-btn @click="openValidDialog" color="secondary" large>{{$t('surveys.validate')}}</v-btn>
                    </div>
                </div>

                <div layout="row" layout-align="start center" layout-wrap class="mt-3">
                    <span @click.prevent="$router.push({name: 'surveys-show-info'})" class="clickable" :class="{'active-param' : $route.name.indexOf('surveys-show-info') == 0}">{{$t('surveys.info')}}</span>
                    <span class="grey--text ml-2 mr-2">|</span>
                    <span @click.prevent="editable ? $router.push({name: 'surveys-show-survey'}) : $router.push({name: 'surveys-show-survey-preview'})" class="clickable" :class="{'active-param' : $route.name.indexOf('surveys-show-survey') == 0}">{{$t('surveys.the_survey')}}</span>
                    <span class="grey--text ml-2 mr-2">|</span>
                    <span @click.prevent="$router.push({name: 'surveys-show-answers'})" class="clickable" :class="{'active-param' : $route.name.indexOf('surveys-show-answers') == 0}">{{$t('surveys.the_answers')}}</span>
                </div>
            </div>
            <router-view name="surveybody" :survey="survey" class="mt10-pc mt2-mobile" :preview="true" flex></router-view>
            <v-dialog
                v-model="deleteDialog"
                max-width="300"
                >
                <v-card>
                    <v-card-title class="title">{{$t('surveys.delete_dialog')}}</v-card-title>
                    <v-card-text>
                        {{$t('surveys.delete_info')}}
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="secondary"
                        flat="flat"
                        @click="deleteDialog = false"
                    >
                        {{$t('_.cancel')}}
                    </v-btn>
                    <v-btn
                        color="error"
                        depressed
                        @click="deleteDialog = false; deleteSurvey()"
                    >
                        {{$t('_.delete')}}
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="validDialog"
                max-width="500"
                >
                <v-card>
                    <v-card-title class="title">{{$t('surveys.valid_dialog')}}</v-card-title>
                    <v-card-text>
                        {{$t('surveys.valid_info')}} ({{$t('_.on')}} {{formatShortDateHumanI18n(survey.message.date_start)}}).
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="secondary"
                        flat="flat"
                        @click="validDialog = false"
                    >
                        {{$t('_.cancel')}}
                    </v-btn>
                    <v-btn
                        color="secondary"
                        depressed
                        @click="validDialog = false; validateSurvey()"
                    >
                        {{$t('_.validate')}}
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="stopDialog"
                max-width="500"
                >
                <v-card>
                    <v-card-title class="title">{{$t('surveys.stop_dialog')}}</v-card-title>
                    <v-card-text>
                        {{$t('surveys.stop_info')}}
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="secondary"
                        flat="flat"
                        @click="stopDialog = false"
                    >
                        {{$t('_.cancel')}}
                    </v-btn>
                    <v-btn
                        color="error"
                        depressed
                        @click="stopDialog = false; stopSurvey()"
                    >
                        {{$t('_.stop')}}
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="dateDialog"
                max-width="500"
                >
                <v-card>
                    <v-card-title class="title">{{$t('surveys.end_pub')}}</v-card-title>
                    <v-card-text>
                        <date-field name="end" v-model="end"/>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="secondary"
                        flat="flat"
                        @click="dateDialog = false"
                    >
                        {{$t('_.cancel')}}
                    </v-btn>
                    <v-btn
                        color="secondary"
                        depressed
                        @click="editEnd()"
                    >
                        {{$t('_.validate')}}
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
    import Surveys from '@/api/surveys'
    import I18nMixin from '@/mixins/i18n'
    import Consts from '@/consts'
    import ImageMixin from '@/mixins/image'
    import Avatar from '@/components/shared/Avatar.vue'
    import Auth from '@/plugins/auth'
    import DateField from '@/components/shared/DateField'
    import moment from 'moment'
    import EventBus from '@/plugins/eventbus'

    export default {
        mixins: [I18nMixin, ImageMixin],
        components: {Avatar, DateField},
        data () {
            return {
                survey: {
                    message: {
                        levels: [],
                        sectors: [],
                        schools: [],
                        cities: [],
                        regions: [],
                        regional_directorates: [],
                    },
                    title: {},
                    creator: {},
                    description: {},
                    thanks: {},
                    pages: {}
                },
                loading: true,
                imgs: {},
                imgsLoad: {},
                deleteDialog: false,
                validDialog: false,
                dateDialog: false,
                stopDialog: false,
                menu: false,
                menu2: false,
                end: ''
            }
        },
        mounted () {
            this.fetch();
            this.$store.commit('LOAD_LOGO');
            EventBus.$on('survey-updated', () => this.fetch());
        },
        destroyed (){
            EventBus.$off('survey-updated');
        },
        methods: {
            fetch () {
                Surveys.get(this.$route.params.id).then(res => {
                    this.survey = res.data;
                    this.end = this.survey.message.date_end;
                    this.loading = false;

                    this.fetchTargets();

                    if(this.survey.creator.avatar_id){
                        this.getImage('/assets/users/' + this.survey.creator_id, this.survey.creator_id);
                    }

                    const pages = {};
                    for(let i = 0; i <  this.survey.pages.length; i++){
                        const p = this.survey.pages[i];

                        //On réindexe les questions par page
                        for(let j = 0; j < p.questions.length; j++){
                            p.questions[j].number = (j + 1);
                        }
                        pages[this.survey.pages[i].number] = p;
                    }

                    pages['+'] = {
						number: "+",
						questions: []
					}
                    if(!this.survey.pages.length){
                        pages['+'].questions = this.survey.questions;
                    }

                    this.survey.pages = pages;
                })
            },
            fetchTargets(){
                Surveys.nbTargets(this.survey.message_id).then(res => {
                    this.survey.nb_targets = res.data;
                })
            },
            levelLabel(l){
                switch (l) {
                    case Consts.MINISTRY:
                        return this.$t('users.lv_min');
                    case Consts.NATIONAL:
                        return this.$t('users.lv_nat');
                    case Consts.SECTORAL:
                        return this.$t('users.lv_sec');
                    case Consts.LOCAL:
                        return this.$t('users.lv_loc');
                }
            },
            surveyStatus(s, o = 1){
                if(!s.message){
                    if(o == 1){
                        return 'red';
                    } else{
                        return this.$t('surveys.suspended');
                    }
                } else if((!s.message.is_enabled || !moment().isSameOrAfter(s.message.date_start)) && !moment().isSameOrAfter(s.message.date_end)){
                    if(o == 1){
                        return 'grey';
                    } else{
                        return this.$t('surveys.draft')
                    }
                } else if(s.message.is_enabled && moment().isSameOrAfter(s.message.date_start) && moment().isSameOrBefore(s.message.date_end)){
                    if(o == 1){
                        return 'orange';
                    } else{
                        return this.$t('surveys.in_progress')
                    }
                } else{
                    if(o == 1){
                        return 'green';
                    } else{
                        return this.$t('surveys.completed')
                    }
                }
            },
            deleteSurvey(){
                Surveys.delete(this.$route.params.id).then(() => {
                   this.$snotify.success(this.$t('surveys.deleted'));
                   this.$router.push({name: 'surveys-index'});
                })
            },
            validateSurvey(){
                Surveys.enable(this.$route.params.id).then(() => {
                   this.$snotify.success(this.$t('surveys.validated'));
                   this.survey.message.is_enabled = 1;
                })
            },
            stopSurvey(){
                Surveys.disable(this.$route.params.id).then(() => {
                   this.$snotify.success(this.$t('surveys.stopped'));
                   this.survey.message.is_enabled = 0;
                   this.survey.message.date_end = moment().format('YYYY-MM-DD hh:mm:ss');
                })
            },
            onEndInput(val){
                this.survey.message.date_end = val;
            },
            editEnd(){
                this.onEndInput(this.end);
                Surveys.editEnd(this.$route.params.id, this.survey.message).then(() => {
                    this.$snotify.success(this.$t('surveys.edited'));
                    this.dateDialog = false;
                })
            },
            exportCSV(){
                Surveys.export(this.$route.params.id).then(res => {
                    let blob = new Blob([res.data], {type: "octet/stream"});
                    let name = "Survey-" + this.i18n(this.survey.title).replace(/\s+/g, '-').toLowerCase() + "-answers-" + moment().format('YYYY-MM-DD-hh-mm-ss') + ".csv";

                    if (window.navigator && window.navigator.msSaveOrOpenBlob){
                        window.navigator.msSaveBlob(blob, name);
                    } else{
                        let a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        let url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = name;
                        a.click();
                        window.URL.revokeObjectURL(url);
                    }
                })
            },
            openDeleteDialog(){
                this.deleteDialog = true;
            },
            openDateDialog(){
                this.dateDialog = true;
            },
            openStopDialog(){
                this.stopDialog = true;
            },
            openValidDialog(){
                this.validDialog = true;
            },
            edit(){
                this.$router.push({name: 'surveys-edit'});
            }
        },
        computed: {
             surveyStatusStr(){
                if(!this.survey.message){
                    return this.$t('surveys.suspended');
                } else if((!this.survey.message.is_enabled || !moment().isSameOrAfter(this.survey.message.date_start)) && !moment().isSameOrAfter(this.survey.message.date_end)){
                    return this.$t('surveys.draft')
                } else if(this.survey.message.is_enabled && moment().isSameOrAfter(this.survey.message.date_start) && moment().isSameOrBefore(this.survey.message.date_end)){
                    return this.$t('surveys.in_progress')
                } else{
                    return this.$t('surveys.completed')
                }
            },
            surveyStatusColor(){
                if(!this.survey.message){
                    return 'red';
                } else if((!this.survey.message.is_enabled || !moment().isSameOrAfter(this.survey.message.date_start)) && !moment().isSameOrAfter(this.survey.message.date_end)){
                    return 'grey';
                } else if(this.survey.message.is_enabled && moment().isSameOrAfter(this.survey.message.date_start) && moment().isSameOrBefore(this.survey.message.date_end)){
                    return 'orange';
                } else{
                    return 'green';
                }
            },
            isMEN(){
                if(this.survey.creator.is_admin || this.survey.creator.level == Consts.MINISTRY){
                    return true;
                }
                return false;
            },
            isCurrent(){
                if(Auth.user.id == this.survey.creator_id){
                    return true;
                }
                return false;
            },
            isCurrentLevel(){
                if(Auth.user.level == this.survey.creator.level){
                    return true;
                }
                return false;
            },
            editable(){
                if(!this.isCurrentLevel || (this.survey.message.is_enabled && moment().isSameOrAfter(this.survey.message.date_start) && moment().isSameOrBefore(this.survey.message.date_end))){
                    return false;
                }
                return true;
            },
            menuList(){
                let list = [
                    {
                        title: this.$t('surveys.edit'),
                        icon: 'pencil',
                        action: () => this.edit(),
                        disabled: !this.editable
                    },
                    {
                        title: this.$t('surveys.delete'),
                        icon: 'delete',
                        color: 'red',
                        text: 'red',
                        action: () => this.openDeleteDialog(),
                        disabled: !this.editable
                    },
                    {
                        title: this.$t('surveys.edit_end'),
                        icon: 'calendar',
                        action: () => this.openDateDialog(),
                        disabled: this.editable || !this.isCurrentLevel
                    },
                    {
                        title: this.$t('surveys.export'),
                        icon: 'cloud-download',
                        action: () => this.exportCSV(),
                        disabled: (!this.survey.message.is_enabled || !moment().isSameOrAfter(this.survey.message.date_start))
                    }
                ];

                if(!this.editable && this.survey.message.is_enabled){
                    list.push({
                        title: this.$t('surveys.stop'),
                        icon: 'minus-circle',
                        color: 'red',
                        text: 'red',
                        action: () => this.openStopDialog(),
                        disabled: !this.isCurrentLevel && Auth.user.level != Consts.MINISTRY
                    });
                }
                if(!this.survey.message.is_enabled && this.survey.message.date_start && this.survey.message.date_end){
                    list.push({
                        title: this.$t('surveys.validate'),
                        icon: 'check-circle',
                        color: 'green',
                        text: 'green',
                        action: () => this.openValidDialog(),
                        disabled: !this.isCurrentLevel
                    });
                }

                return list;
            },
        }
    }
</script>
<style scoped>
.active-param {
  font-weight: bold;
  color: #2e3b7f;
}
.message-btn {
  height: 14px;
  width: 14px;
  border: 1px;
  border-radius: 50% 50%;
}
</style>